import Utils from "./utils-service.js";
import Funnel from "./funnel-service.js";

export default class Home {

    constructor(lib) {
        this.ctx = lib.ctx;
        this.router = lib.router;
        this.fs = new Funnel({ ctx: lib.ctx });
    }

    pg_home_prefill(payload){
        console.log(payload)
    }

    pg_home_basic_info(payload){
        console.log(payload)

        if(!this.fs.isBundle()) {
            this.fs.setDefaultEffectiveDate('in_home_effective_date', 8);
        }
    }

    pg_home_bathrooms(payload){
        console.log(payload)
    }

    pg_home_location(payload){
        console.log(payload)
    }

    pg_home_structure(payload){
        console.log(payload)
    }

    pg_home_foundation(payload){
        console.log(payload)
        const uid = 'in_home_foundation';
        payload[uid]['options'] = this.ctx.getters.funnel.elements[uid]['options'];
    }

    pg_home_roof(payload){
        console.log(payload)
    }

    pg_home_utilities(payload){
        console.log(payload)
    }

    pg_home_heating(payload){
        console.log(payload)
    }

    pg_home_security(payload){
        console.log(payload)
    }

    pg_home_extras(payload){
        console.log(payload)
    }

    pg_home_state_questions(payload){
        console.log(payload)
    }

    pg_home_coverage_carrier(payload){
        console.log(payload)

        const $fs = new Funnel({ ctx: this.ctx });

        if($fs.isBundle()){
            let homeCarrier = payload['in_home_coverage_carrier']['value']
            let autoCarrier = this.ctx.getters.funnel.elements['in_coverage_carrier'].value

            if(homeCarrier === autoCarrier){
                if(this.ctx.getters.funnel.elements['in_current_carrier_length'].value){
                    this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: 'in_home_coverage_current_carrier_years', key: 'value', val: this.ctx.getters.funnel.elements['in_current_carrier_length'].value })
                    $fs.processCurrCarrierLenDependentElems('change', 'in_home_coverage_current_carrier_years')
                }

                if(this.ctx.getters.funnel.elements['in_coverage_current_continuous'].value){
                    this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: 'in_home_coverage_current_continuous', key: 'value', val: this.ctx.getters.funnel.elements['in_coverage_current_continuous'].value })
                }
            }
        }
    }

    pg_home_coverage_current(payload){
        console.log(payload)
    }

    pg_home_claims_start(payload){
        console.log(payload)
    }

    pg_home_claims(payload){
        console.log(payload)
    }

    pg_home_replacement_cost(payload){
        console.log(payload)

        let replacement_cost = this.ctx.state.funnel.elements.in_home_replacement_cost.raw_value

        if(replacement_cost != ""){
            var percentIncrements = 5
            let personalPropertyOptions = []
            let defaultPct = 50
            let defaultPPVal

            for(let pct = 20; pct <= 50; pct = pct + percentIncrements){
                personalPropertyOptions.push(
                    {
                        "value": Math.floor(parseInt(replacement_cost) * (pct * 0.01)),
                        "label": new Intl.NumberFormat('en-US', {
                            style: 'currency',
                            currency: 'USD',
                            maximumFractionDigits: 0
                        }).format(Math.floor(parseInt(replacement_cost) * (pct * 0.01)))
                    }
                )

                if(pct == defaultPct){
                    defaultPPVal = Math.floor(parseInt(replacement_cost) * (pct * 0.01))
                }
            }

            this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: 'in_home_personal_property', key: 'options', val: personalPropertyOptions })
            this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: 'in_home_personal_property', key: 'value', val: defaultPPVal })

            payload["in_home_personal_property"] = {}
            payload["in_home_personal_property"]["value"] = defaultPPVal
            payload["in_home_personal_property"]["options"] = personalPropertyOptions

            return
        }
    }

    pg_home_coverage_select(payload){
        console.log(payload)
    }

    pg_home_effective_date(payload){
        console.log(payload)
    }

    homeCoverageCarrierNoPrior(elem){
        console.log(elem)
        console.log('carrier == ', elem.target.value)

        // remove pg_home_coverage_current page if no prior insurance
        if(elem.target.value == 'no'){
            console.log('pg_home_coverage_current deleted')
            this.ctx.commit('DELETE_PAGE_SEQ', ['pg_home_coverage_current']);
        }
        else{
            console.log('pg_home_coverage_current added')
            this.ctx.commit('ADD_PAGE_SEQ_TO_POS', [{
                "puid": "pg_home_coverage_current",
                "pos": "after",
                "refUids": ["pg_home_coverage_carrier"]
            }]);
        }
        return;
    }

    homePrefillModalDisplay(elem){
        if(elem.target.value == 'No'){
            console.log('pg_home_prefill deleted')
            this.ctx.commit('DELETE_PAGE_SEQ', ['pg_home_prefill']);
        }
        else{
            console.log('pg_home_prefill added')

            this.ctx.commit('ADD_PAGE_SEQ_TO_POS', [{
                "puid": "pg_home_prefill",
                "pos": "before",
                "refUids": ["pg_home_basic_info"]
            }]);
        }
        return;
    }

    claimsPageDisplay(elem, input){
        if(input.value == 0){
            console.log('pg_home_claims deleted')
            this.ctx.commit('DELETE_PAGE_SEQ', ['pg_home_claims']);
        }
        else{
            console.log('pg_home_claims added')

            this.ctx.commit('ADD_PAGE_SEQ_TO_POS', [{
                "puid": "pg_home_claims",
                "pos": "after",
                "refUids": ["pg_home_claims_start"]
            }]);
        }
        return;
    }
}